import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { NavigationService } from '../../services';
import { filter, map } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { CognitoService } from '../../services/cognito.service';
import config from 'src/assets/config/config.json';

@Component({
    selector: 'app-menu',
    templateUrl: './app-menu.component.html',
    styleUrls: ['./app-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatExpansionModule]
})
export class AppMenuComponent {
  private navigationService = inject(NavigationService);
  private cognitoService = inject(CognitoService);
  private router = inject(Router);

  currentUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => location.href)
    ),
    { initialValue: location.href }
  );

  isAdmin = signal(false);

  constructor() {
    this.cognitoService.isAdmin().then(isAdmin => {
      this.isAdmin.set(isAdmin);
    });
  }

  isRouteSelected(route: string): boolean {
    return this.currentUrl().includes(route);
  }

  navigate(path: string) {
    this.navigationService.navigateToRoute(path);
  }

  openDashboard() {
    window.open((config as any).grafanaUrl, '_blank');
  }
}
